'use strict';

(function () {
  if (!customElements.get('announcement-bar')) {
    class AnnouncementBar extends HTMLElement {
      constructor() {
        super();

        this.slider = this.querySelector('.swiper');
        this.nextBtn = this.querySelector('.swiper-button-next');
        this.prevBtn = this.querySelector('.swiper-button-prev');

        this.slides = [];
        this.currentIndex = 0;
        this.autoplayTimer = null;

        this.handleNext = this.handleNext.bind(this);
        this.handlePrev = this.handlePrev.bind(this);
        this.handleResize = this.handleResize.bind(this);
      }

      connectedCallback() {
        if (!this.slider) return;

        this.slides = Array.from(
          this.slider.querySelectorAll('.swiper-slide')
        );

        if (!this.slides.length) return;

        const {
          speed = 300,
          changeSpeed = 5000,
          slidesPerView = 1,
          rotate = 'false'
        } = this.slider.dataset;

        this.speed = parseInt(speed, 10) || 300;
        this.changeSpeed = parseInt(changeSpeed, 10) || 5000;
        this.desktopSlidesPerView =
          Math.max(1, parseInt(slidesPerView, 10) || 1);

        this.rotate = rotate === 'true';

        this.prepareSlider();
        this.render();

        if (this.slides.length <= 1) {
          if (this.nextBtn) this.nextBtn.style.display = 'none';
          if (this.prevBtn) this.prevBtn.style.display = 'none';
        } else {
          if (this.nextBtn) {
            this.nextBtn.addEventListener('click', this.handleNext);
          }

          if (this.prevBtn) {
            this.prevBtn.addEventListener('click', this.handlePrev);
          }
        }

        window.addEventListener('resize', this.handleResize);

        this.startAutoplay();
      }

      disconnectedCallback() {
        this.stopAutoplay();

        if (this.nextBtn) {
          this.nextBtn.removeEventListener('click', this.handleNext);
        }

        if (this.prevBtn) {
          this.prevBtn.removeEventListener('click', this.handlePrev);
        }

        window.removeEventListener('resize', this.handleResize);
      }

      prepareSlider() {
        const wrapper = this.slider.querySelector('.swiper-wrapper');

        if (wrapper) {
          wrapper.style.display = 'flex';
          wrapper.style.width = '100%';
        }

        this.slides.forEach((slide) => {
          slide.style.transition = `opacity ${this.speed}ms ease`;
          slide.style.boxSizing = 'border-box';
        });
      }

      getSlidesPerView() {
        if (window.innerWidth < 750) {
          return 1;
        }

        return Math.min(
          this.desktopSlidesPerView,
          this.slides.length
        );
      }

      render() {
        const slidesPerView = this.getSlidesPerView();

        this.slides.forEach((slide, index) => {
          let relativeIndex =
            (index - this.currentIndex + this.slides.length) %
            this.slides.length;

          const visible = relativeIndex < slidesPerView;

          slide.style.display = visible ? '' : 'none';
          slide.style.opacity = visible ? '1' : '0';

          if (visible) {
            slide.style.flex = `0 0 ${100 / slidesPerView}%`;
            slide.removeAttribute('aria-hidden');
          } else {
            slide.style.flex = '';
            slide.setAttribute('aria-hidden', 'true');
          }
        });
      }

      handleNext() {
        this.currentIndex =
          (this.currentIndex + 1) % this.slides.length;

        this.render();
        this.restartAutoplay();
      }

      handlePrev() {
        this.currentIndex =
          (this.currentIndex - 1 + this.slides.length) %
          this.slides.length;

        this.render();
        this.restartAutoplay();
      }

      handleResize() {
        this.render();
      }

      startAutoplay() {
        if (!this.rotate || this.slides.length <= 1) return;

        this.stopAutoplay();

        this.autoplayTimer = setInterval(() => {
          this.currentIndex =
            (this.currentIndex + 1) % this.slides.length;

          this.render();
        }, this.changeSpeed);
      }

      stopAutoplay() {
        if (this.autoplayTimer) {
          clearInterval(this.autoplayTimer);
          this.autoplayTimer = null;
        }
      }

      restartAutoplay() {
        if (!this.rotate) return;

        this.startAutoplay();
      }
    }

    customElements.define('announcement-bar', AnnouncementBar);
  }
})();